module.exports = __webpack_public_path__ + "static/Tracer Peer-to-Peer Finance-65f1127836ed89aad6c5ef39032bedf8.pdf";